(function() { module.exports = window["eventespresso"]["registry"]; }());